import { axios } from '@/services/axios';

const getTrunkTypes = async (currentScope) => {
    const res = await axios.get('/trunktypes', {
        headers: { 'X-RequestScope': currentScope },
    });
    return res.data;
};

export default getTrunkTypes;
